var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.lists),function(list,i){return _c('ContentLoader',{key:i,class:[
      'transform-scale-0',
      { 'tw-mb-4': _vm.listLength > 1 },
      _vm.listClasses[i] || _vm.listClasses[3]
    ],attrs:{"width":760,"height":80,"speed":2,"primaryColor":"#f3f3f3","secondaryColor":"#ecebeb"}},[_c('rect',{attrs:{"x":"20","y":"0","rx":"0","ry":"0","width":"720","height":"80"}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }